import { defineStore } from "pinia"

export const useAdmininfo = defineStore('admin', {
    // defineStore(id(一个储存库标识))
    state: () => ({
        id: null,
        companycode: null,
        acccompanycode: null,
        login: null,
        password: null,
        addinfo7: null,
        //用户账户所在的国家
        country: null,
        token: null,
        //商家id
        businessId: null,
        //商家Login
        businessLogin: null,
        //商家密碼
        businessPassword: null,
    }),
    persist: true,
})